define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/PhoneNumberStatusModel", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, PhoneNumberStatusModel, UserContext) {
    "use strict";
    var PhoneNumberStatuses = /** @class */ (function () {
        function PhoneNumberStatuses() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,PhoneNumberStatus.Edit,PhoneNumberStatus.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,PhoneNumberStatus.Delete"));
            this.editModel = ko.observable(new PhoneNumberStatusModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
        }
        PhoneNumberStatuses.prototype.init = function () {
            var self = this;
            $("#page-title").text("Phone Number Statuses");
            tools.ajaxGet({
                url: "/PhoneNumberStatus/GetPhoneNumberStatusesLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initPhoneNumberStatuses(self.lookupLists.GridStructures.PhoneNumberStatusStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        PhoneNumberStatuses.prototype.initPhoneNumberStatuses = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEdit()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDelete()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            });
            var gridId = "phoneNumberStatusesTable";
            self.PhoneNumberStatusTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    //reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    }
                    //toolbar: kendo.template($("#product-type-toolbar-template").html())
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/PhoneNumberStatus/GetPhoneNumberStatuses",
                            type: "POST",
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "PhoneNumberStatus",
                    title: "Phone Number Statuses",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.PhoneNumberStatusTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.PhoneNumberStatusTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editPhoneNumberStatus(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deletePhoneNumberStatusConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        PhoneNumberStatuses.prototype.editPhoneNumberStatus = function (id) {
            var self = this;
            var title = id > 0 ? "Edit Phone Number Status" : "Add Phone Number Status";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Name is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.savePhoneNumberStatus(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/PhoneNumberStatus/GetPhoneNumberStatusById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new PhoneNumberStatusModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new PhoneNumberStatusModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'phone-number-status-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        PhoneNumberStatuses.prototype.savePhoneNumberStatus = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/PhoneNumberStatus/SavePhoneNumberStatus",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.PhoneNumberStatusTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        PhoneNumberStatuses.prototype.deletePhoneNumberStatusConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Phone Number Status",
                text: 'Are you sure you want to delete phone number status "' + name + '"?',
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deletePhoneNumberStatus(id);
            });
        };
        PhoneNumberStatuses.prototype.deletePhoneNumberStatus = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/PhoneNumberStatus/DeletePhoneNumberStatusConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Phone number status deleted successfully");
                    self.PhoneNumberStatusTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        PhoneNumberStatuses.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        PhoneNumberStatuses.prototype.exportTo = function () {
            var self = this;
            self.PhoneNumberStatusTable.exportTo();
        };
        PhoneNumberStatuses.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("PhoneNumberStatus");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return PhoneNumberStatuses;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/PhoneNumberStatus/Index")) {
            log.log("Initialize Phone Number Statuses");
            $(function () {
                (new PhoneNumberStatuses()).init();
            });
        }
    }, 0);
    return PhoneNumberStatuses;
});
//# sourceMappingURL=phoneNumberStatuses.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/settings/phoneNumberStatuses.js
// module id = 228
// module chunks = 2